var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"title":"选择授权目标","visible":_vm.visible,"close-on-click-modal":false,"width":"400px","top":"20vh","append-to-body":""},on:{"update:visible":function($event){_vm.visible=$event}}},[_c('UserSearch',{on:{"onUserSelected":_vm.onUserSelected}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }